import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";

export const propertiesGridColumns: PolluxGridConfig[] = [
  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: 'property.propertyType',
    field: "PropertyType",
    width: 200
  },
  {
    title: 'property.propertySubType',
    field: "PropertySubType",
    width: 200
  },
  {
    title: 'property.noJll',
    field: "NoJll",
    width: 200
  }, {
    title: 'property.portfolioName',
    field: "PortfolioName",
    width: 200
  }, {
    title: 'property.buildingName',
    field: "buildingName",
    width: 200
  }, {
    title: 'property.countryID',
    field: "CountryIDDescription",
    width: 200
  }, {
    title: 'property.province',
    field: "RegionManual",
    width: 200
  }, {
    title: 'property.municipalManual',
    field: "MunicipalManual",
    width: 200
  }, {
    title: 'property.postalCodeManual',
    field: "PostalCodeManual",
    width: 200
  }, {
    title: 'property.subLocation',
    field: "subLocationDescription",
    width: 200
  }, {
    title: 'property.street1',
    field: "Street1",
    width: 200
  }, {
    title: 'property.streetNo1',
    field: "StreetNo1",
    width: 200
  }, {
    title: 'property.houseNoTo',
    field: "houseNoTo",
    width: 200
  }, {
    title: 'property.houseNoAd',
    field: "houseNoAd",
    width: 200
  }, {
    title: 'property.tenure',
    field: "tenureDescription",
    width: 200
  }, {
    title: 'property.buildingYear',
    field: "buildingYear",
    width: 200
  }, {
    title: 'property.renovationYear',
    field: "renovationYear",
    width: 200
  }, {
    title: 'property.energyPerformanceLabel',
    field: "energyPerformanceLabelDescription",
    width: 200
  }, {
    title: 'property.energyCertificate',
    field: "energyCertificateDescription",
    width: 200
  }, {
    title: 'property.street2',
    field: "Street2",
    width: 200
  }, {
    title: 'property.streetNo2',
    field: "StreetNo2",
    width: 200
  }, {
    title: 'property.houseNo2To',
    field: "houseNo2To",
    width: 200
  }, {
    title: 'property.houseNo2Ad',
    field: "houseNo2Ad",
    width: 200
  }, {
    title: 'property.noNl',
    field: "NoNl",
    width: 200
  }, {
    title: 'property.oid',
    field: "Oid",
    width: 200
  },
  {
    title: 'property.propertyHorizonId',
    field: "propertyHorizonId",
    width: 200
  },
  {
    title: 'property.propertyMDMId',
    field: "propertyMDMId",
    width: 200
  },
  {
    title: 'property.opportunityPropertyId',
    field: "opportunityPropertyId",
    width: 200
  },
  {
    title: 'property.createdDate',
    field: "CreatedDate",
    type: 'date',
    width: 200
  }, {
    title: 'property.ownerUserID',
    field: "OwnerUserIDDescription",
    width: 200
  }, {
    title: 'property.modifiedDate',
    field: "ModifiedDate",
    type: 'date',
    width: 200
  }, {
    title: 'property.modifiedByUserId',
    field: "ModifiedByUserIdDescription",
    width: 200
  }, {
    title: 'property.longitude',
    field: "Longitude",
    width: 200
  }, {
    title: 'property.latitude',
    field: "Latitude",
    width: 200
  }, {
    title: 'property.coordinatesQuality',
    field: "coordinatesQualityDescription",
    width: 200
  }, {
    title: 'property.projectStdID',
    field: "ProjectStdIDDescription",
    width: 200
  }, {
    title: 'property.assignedTemplateName',
    field: "assignedTemplateName",
    width: 200
  },
  {
    title: 'property.valuationEffectiveStartDate',
    field: "ValuationEffectiveStartDate",
    type: 'date',
    width: 200
  },
  {
    title: 'property.valuationEffectiveEndDate',
    field: "ValuationEffectiveEndDate",
    type: 'date',
    width: 200
  }
];
